class INTENT.widgets.CreativeGoogleStatusHistory

  @ATTR_NAME: "data-widget-creative-gstatus-history"

  @ATTR_CREATIVE_ID: "data-creative-id"

  constructor: (@el) ->
    @s = @.constructor

    @creative_id = $(@el).attr("#{@s.ATTR_CREATIVE_ID}")

    if not @creative_id
      console.error "Invalid #{@s.ATTR_CREATIVE_ID} attribute value"
      return

    @el.on "click", =>
      @show_history()


  show_history: =>
    @el.showLoader()
    $.getJSON "/ajax/creative_status_history", {creative_id: @creative_id}
    .done (resp) =>
      @el.hideLoader()

      modalSettings =
        title: __ 'creative.status.change_history'
        body: INTENT.utils.Template.get_table headrows, bodyrows
        size: "large"

      if resp.error?
        INTENT.utils.Notify.error resp.error

      if 0 == resp.rowset.length
        modalSettings.body  = INTENT.utils.Template.wrap_in_p (__ 'creative.status.history_is_empty')
        INTENT.utils.Modal.show modalSettings
        return

      headrows = ''
      bodyrows = ''

      # column_names
      for thVal in resp.column_names
        headrows += INTENT.utils.Template.get_th_row (INTENT.utils.Helper.ucfirst thVal)

      for row in resp.rowset
        tdrows = ''
        for tdKey, tdVal of row
          tdrows += INTENT.utils.Template.get_td_row tdVal

        bodyrows += INTENT.utils.Template.get_tr_row tdrows

      modalSettings.body = (INTENT.utils.Template.get_table headrows, bodyrows)
      INTENT.utils.Modal.show modalSettings


    .fail =>
      @el.hideLoader()

